import { assign } from '..';
import { ClickAreaProps } from '../../../types';

export class ClickAreaBuilder {
  public static create({
    positionXPercentage,
    positionYPercentage,
    widthPercentage,
    heightPercentage
  }: ClickAreaProps): HTMLElement {
    // Full-screen overlay blocker
    const clickBlockingArea = document.createElement('div');
    clickBlockingArea.style.position = 'absolute';
    clickBlockingArea.style.top = '0';
    clickBlockingArea.style.left = '0';
    clickBlockingArea.style.right = '0';
    clickBlockingArea.style.bottom = '0';
    clickBlockingArea.style.zIndex = '2147483657';

    // Block all events
    [
      'pointerdown',
      'pointerup',
      'click',
      'mousedown',
      'mouseup',
      'touchstart',
      'touchend'
    ].forEach(evt =>
      clickBlockingArea.addEventListener(
        evt,
        e => {
          e.stopImmediatePropagation();
          e.preventDefault();
        },
        true
      )
    );

    // Clamp values to [0, 100]
    const top = Math.max(0, Math.min(100, positionYPercentage));
    const left = Math.max(0, Math.min(100, positionXPercentage));
    const width = Math.max(0, Math.min(100 - left, widthPercentage));
    const height = Math.max(0, Math.min(100 - top, heightPercentage));

    const zones = [];

    if (top > 0) {
      zones.push({ top: 0, left: 0, width: 100, height: top });
    }
    if (left > 0) {
      zones.push({ top, left: 0, width: left, height });
    }
    if (left + width < 100) {
      zones.push({
        top,
        left: left + width,
        width: 100 - (left + width),
        height
      });
    }
    if (top + height < 100) {
      zones.push({
        top: top + height,
        left: 0,
        width: 100,
        height: 100 - (top + height)
      });
    }

    zones.forEach(zone => {
      // Create nonClickableArea divs
      const nonClickableArea = document.createElement('div');
      assign(nonClickableArea.style, {
        position: 'absolute',
        top: `${zone.top}%`,
        left: `${zone.left}%`,
        width: `${zone.width}%`,
        height: `${zone.height}%`,
        pointerEvents: 'auto' // Make clickableAreas interactive
      });

      clickBlockingArea.appendChild(nonClickableArea);
    });

    // Make blocker ignore pointer events on clickableArea area
    clickBlockingArea.style.pointerEvents = 'none';
    return clickBlockingArea;
  }
}
